var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from "pixi.js";
import { deformVertexSrc, simpleVertexSrc } from "./vertexShader";
import { colorFragmentSrc } from "./fragmentShader";
export var CARET_POSITION;
(function (CARET_POSITION) {
    CARET_POSITION[CARET_POSITION["START"] = 0] = "START";
    CARET_POSITION[CARET_POSITION["END"] = 1] = "END";
})(CARET_POSITION || (CARET_POSITION = {}));
export var SELECTION_DIRECTION;
(function (SELECTION_DIRECTION) {
    SELECTION_DIRECTION[SELECTION_DIRECTION["LEFT"] = 0] = "LEFT";
    SELECTION_DIRECTION[SELECTION_DIRECTION["RIGHT"] = 1] = "RIGHT";
})(SELECTION_DIRECTION || (SELECTION_DIRECTION = {}));
var FontAtlasTextCaret = /** @class */ (function (_super) {
    __extends(FontAtlasTextCaret, _super);
    function FontAtlasTextCaret(fontAtlasText) {
        var _this = _super.call(this) || this;
        _this.fontAtlasText = undefined;
        _this._dirty = false;
        _this._glyphIndex = -1;
        _this._glyphPosition = CARET_POSITION.START;
        _this.caretWidth = 2;
        _this._mesh = null;
        _this._caretLastVisibilitySwitch = Date.now();
        _this.caretVisibleDuration = 500;
        _this.fontAtlasText = fontAtlasText;
        _this._createMesh(new PIXI.Geometry());
        return _this;
    }
    Object.defineProperty(FontAtlasTextCaret.prototype, "glyphIndex", {
        get: function () {
            return this._glyphIndex;
        },
        set: function (value) {
            if (this.glyphIndex === value) {
                return;
            }
            if (this.glyphIndex > this.fontAtlasText.text.length - 1) {
                console.warn("glyphIndex ".concat(this.glyphIndex, " is out of bounds. Setting to ").concat(this.fontAtlasText.text.length - 1));
            }
            this._glyphIndex = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasTextCaret.prototype, "glyphPosition", {
        get: function () {
            return this._glyphPosition;
        },
        set: function (value) {
            if (this.glyphPosition === value) {
                return;
            }
            this._glyphPosition = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    FontAtlasTextCaret.prototype._update = function () {
        if (!this._dirty) {
            return;
        }
        if (this._glyphIndex === -1) {
            return;
        }
        var token = this.fontAtlasText.text[this.glyphIndex];
        var vertexArray = this.fontAtlasText.getGlyphVertexArray(this.glyphIndex);
        var lineHeight = this.fontAtlasText.atlas.fontSize * this.fontAtlasText._fontFactor;
        var x0, x1, y0, y1;
        // no text
        if (this.fontAtlasText.text.length === 0) {
            x0 = 0;
            x1 = this.caretWidth;
            y0 = 0;
            y1 = lineHeight;
        }
        // @ts-ignore
        // new line
        else if (PIXI.TextMetrics.isNewline(token)) {
            x0 = 0;
            x1 = this.caretWidth;
            var line = Math.ceil(vertexArray[7] / lineHeight);
            if (this.glyphPosition === CARET_POSITION.START) {
                line -= 1;
            }
            y0 = line * lineHeight;
            y1 = (line + 1) * lineHeight;
        }
        // text
        else {
            if (this.glyphPosition === CARET_POSITION.START) {
                var x = vertexArray[4] < this.caretWidth ? this.caretWidth : vertexArray[4];
                x0 = x - this.caretWidth;
                x1 = x;
            }
            else {
                var x = vertexArray[0] < 0 ? 0 : vertexArray[0];
                x0 = x;
                x1 = x + this.caretWidth;
            }
            var line = Math.ceil(vertexArray[7] / lineHeight);
            y0 = (line - 1) * lineHeight;
            y1 = line * lineHeight;
        }
        var caretVertices = [
            x1, y1,
            x1, y0,
            x0, y0,
            x0, y1,
        ];
        var caretIndices = [0, 1, 2, 2, 3, 0];
        var geometry = new PIXI.Geometry();
        geometry.addAttribute('aVertexPosition', caretVertices, 2);
        geometry.addIndex(caretIndices);
        this._mesh.geometry = geometry;
        this._dirty = false;
    };
    FontAtlasTextCaret.prototype._createMesh = function (geometry) {
        var color = [1.0, 0, 0, 1.0];
        var shader;
        // simple
        if (!this.fontAtlasText._curveTexture) {
            var uniforms = {
                uColor: color,
            };
            var vertexShader = simpleVertexSrc(false);
            shader = PIXI.Shader.from(vertexShader, colorFragmentSrc, uniforms);
        }
        // deformed
        else {
            var uniforms = {
                // color
                uColor: color,
                // deform
                texture: this.fontAtlasText._curveTexture,
                pathOffset: this.fontAtlasText._pathOffset,
                pathSegment: this.fontAtlasText._pathSegment,
                spineOffset: this.fontAtlasText._spineOffset,
                spineLength: this.fontAtlasText._spineLength,
                flow: this.fontAtlasText._flow,
            };
            var vertexShader = deformVertexSrc(false);
            shader = PIXI.Shader.from(vertexShader, colorFragmentSrc, uniforms);
        }
        var mesh = new PIXI.Mesh(geometry, shader);
        this._mesh = mesh;
        this.addChild(mesh);
    };
    FontAtlasTextCaret.prototype._toggleVisibility = function () {
        var now = Date.now();
        if ((this._caretLastVisibilitySwitch + this.caretVisibleDuration) > now) {
            return;
        }
        this._caretLastVisibilitySwitch = Date.now();
        if (!this._mesh) {
            return;
        }
        if (this._mesh.visible === true) {
            this._mesh.visible = false;
        }
        else {
            this._mesh.visible = true;
        }
    };
    FontAtlasTextCaret.prototype._render = function (renderer) {
        // we need to make sure our text is up to date
        this.fontAtlasText._render(renderer);
        this._update();
        if (this.caretVisibleDuration !== 0) {
            this._toggleVisibility();
        }
        _super.prototype._render.call(this, renderer);
    };
    return FontAtlasTextCaret;
}(PIXI.Container));
export { FontAtlasTextCaret };
